<template>
  <button class="clear-input" @click="$emit('clear-input-field')">
    <IconClear />
  </button>
</template>

<script>
import IconClear from '@/components/ui/icons/icon-clear.svg'

export default {
  components: {
    IconClear,
  },
}
</script>

<style lang="scss">
@import '../../../../css/import/vars';

.clear-input {
  border: none;
  outline: none;
  background: none;
  position: absolute;
  top: 1px;
  bottom: 1px;
  right: 2rem;

  &:hover,
  &:focus,
  &:active {
    border: none;
    outline: none;
    background: none;
  }
}
</style>
